"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "flex items-center",
    class: {
      clearable: _vm.showClear
    }
  }, [_c("date-time-picker", {
    staticClass: "flex-1 date-time-range-begin",
    attrs: {
      open: _vm.beginOpen,
      placeholder: "选择开始时间",
      "allow-clear": false,
      precision: _vm.precision
    },
    on: {
      openChange: _vm.handleBeginOpenChange,
      confirm: _vm.handleBeginConfirm
    },
    model: {
      value: _vm.selectRange[0],
      callback: function ($$v) {
        _vm.$set(_vm.selectRange, 0, $$v);
      },
      expression: "selectRange[0]"
    }
  }), _c("div", {
    staticClass: "!w-[20px] h-[32px] leading-[32px] border-y border-x-0 border-solid border-[#d9d9d9] text-center"
  }, [_vm._v(" ~ ")]), _c("date-time-picker", {
    ref: "endPickerRef",
    staticClass: "flex-1 date-time-range-end",
    attrs: {
      open: _vm.endOpen,
      placeholder: "选择结束时间",
      "default-time": "23:59:59",
      "allow-clear": false,
      precision: _vm.precision
    },
    on: {
      openChange: _vm.handleEndOpenChange,
      confirm: _vm.handleEndConfirm
    },
    model: {
      value: _vm.selectRange[1],
      callback: function ($$v) {
        _vm.$set(_vm.selectRange, 1, $$v);
      },
      expression: "selectRange[1]"
    }
  }), _vm.showClear ? _c("div", {
    staticClass: "!w-[40px] h-[32px] leading-[32px] border border-l-0 border-solid border-[#d9d9d9] text-center"
  }, [_c("a-icon", {
    staticClass: "cursor-pointer !text-[#bfbfbf] hover:!text-[#8c8c8c] transition-all",
    attrs: {
      slot: "suffix",
      type: "close-circle",
      theme: "filled"
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.handleClear.apply(null, arguments);
      }
    },
    slot: "suffix"
  })], 1) : _vm._e()], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;